export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_PASSWORDLESS = 'LOGIN_PASSWORDLESS';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';